import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import LineChart from '@/components/charts/line-chart/line-chart';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import AtcChart from '@/components/charts/atc-chart/atc-chart';
import { numberFormat } from '@/helpers/number-format';
import { ReportData } from '@/models/groups/report';
import { ClassCompetencyData } from '@/models/groups/class';
import PdfGenerator from '@/components/pdf-generator/pdf-generator';
import CompetencyReportCSV from '@/components/csv-pages/competency-report/competency-report';

@Component({
    name: 'drill-down-chart',
    components: {
        'line-chart': LineChart,
        'material-icon': GoogleMaterialIcon,
        'atc-view': AtcChart,
        'pdf-generator': PdfGenerator,
        'competency-report-csv': CompetencyReportCSV,
    },
})

export default class DrillDownChart extends Vue {

    private get drilldown() {
        return this.competencyData && this.competencyData.drilldown ? this.competencyData.drilldown : [];
    }

    private get coordinates() {
        return this.competencyData && this.competencyData.coordinates ? this.competencyData.coordinates : [];
    }

    private get totalCompetencyGained() {
        const perfData = this.groupType === 'class' ? this.classCompetencyData : this.competencyData;
        return perfData && perfData.overallStats ? perfData.overallStats.overallMasteredCompetencies : [];
    }

    private get chartData() {
        return this.coordinates
            ? this.coordinates
            : this.studentList;
    }

    get isShowCompetencyView() {
        return this.groupType !== 'class';
    }

    private get enabledTenantSettings() {
        return this.tenantSettings
            && (this.tenantSettings.domain_diagnostic_enabled === 'true'
                || this.tenantSettings.show_present_diagnostic_setting_in_class === 'true');
    }

    get classStudentCompetencyData() {
        return this.classCompetencyData && this.classCompetencyData.drilldown ? this.classCompetencyData.drilldown : [];
    }

    get pullupActiveSubject() {
        if (this.selectedSubject) {
            this.dropdownText = this.selectedSubject.title;
            if (this.selectedSubject.title.length > 12) {
                this.dropdownText = this.selectedSubject.title.substring(0, 7) + '...';
            }
        }
        return this.selectedSubject;
    }

    // -------------------------------------------------------------------------
    // Properties

    @Prop()
    private selectedSubject!: any;

    @Prop()
    private groupType!: string;

    @Prop()
    private breadcrumbItems?: Array<{ id: number, name: string, type: string }>;

    @Prop()
    private studentList: any;

    @Prop()
    private competencyData!: ReportData;

    @Prop({ default: '' })
    private entityName: any;

    @Prop()
    private frequency!: string;

    @Prop()
    private classCompetencyData!: ClassCompetencyData;

    @Prop()
    private activeMonth!: string;

    @Prop()
    private activeYear!: string;

    @Prop({ default: false })
    private isLoading!: boolean;

    @Prop()
    private subjectList: any;

    @Prop()
    private tenantSettings: any;

    @Prop()
    private propData: any;

    private breadcrumbList: any = [];

    private hideScore: boolean = false;

    private breadcrumb: any = [];

    private breadcrumbsList: any = [];

    private urldata: any = {};

    private activeSubject: any = null;

    private isExcludeInferred: boolean = false;

    @Prop({ default: false })
    private isReportData!: boolean;

    private dropdownText: string = '';

    @Watch('breadcrumbItems')
    private onLoadBreadcrumbList() {
        let textCount = 0;
        let breadcrumbList: any[] = [];
        const container = this.$el.querySelector('.chart-nav-tab') as HTMLElement;
        const containerWidth = container ? container.offsetWidth : 0;
        const dummyItem = [{ name: '...', default: true }];
        if (this.breadcrumbItems && this.breadcrumbItems.length) {
            this.breadcrumbItems.map((item) => textCount += item.name.length);
            breadcrumbList = textCount > containerWidth
                ? [this.breadcrumbItems[0], ...dummyItem, this.breadcrumbItems[this.breadcrumbItems.length - 1]]
                : this.breadcrumbItems;
        }
        this.breadcrumbList = breadcrumbList;
    }

    // ----------------------------------------------------------------------
    // Hooks
    private mounted() {
        this.onLoadBreadcrumbList();
    }

    // -------------------------------------------------------------------------
    // Actions

    private onChangeBreadcrumb(seletedLevel: any) {
        this.$emit('onChangeBreadcrumb', seletedLevel, this.activeSubject);
    }

    private onBack() {
        this.$emit('onBack');
    }

    private onSelectSubject(subject: any = null) {
        this.activeSubject = subject;
        this.$emit('onSelectSubject', subject);
    }

    private onToggleInferred() {
        this.$emit('onToggleInferred', this.isExcludeInferred);
    }

    private onGeneratePdf() {
        const pdfLoader: any = this.$refs.pdfLoader;
        pdfLoader.onGeneratePdf();
    }


    // --------------------------------------------------------------------------
    // Methods

    private numberFormat(value: number) {
        return numberFormat(value);
    }

    private beforeDownload(configObj: any) {
        const { html2pdf, options, pdfContent } = configObj;
        html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf: any) => {
            (this.$refs.pdfLoader as any).isLoading = false;
        }).save();
    }




}
